/**
 * @namespace {BX.UI}
 */
export default class CounterColor
{
	static DANGER = "ui-counter-danger";
	static WARNING = "ui-counter-warning";
	static SUCCESS = "ui-counter-success";
	static PRIMARY = "ui-counter-primary";
	static GRAY = "ui-counter-gray";
	static LIGHT = "ui-counter-light";
	static WHITE = "ui-counter-white";
	static DARK = "ui-counter-dark";
	static THEME = "ui-counter-theme";
}
